import { render } from "./StructureView.vue?vue&type=template&id=3126352a&scoped=true"
import script from "./StructureView.vue?vue&type=script&lang=js"
export * from "./StructureView.vue?vue&type=script&lang=js"

import "./StructureView.vue?vue&type=style&index=0&id=3126352a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3126352a"]])

export default __exports__